import type { TopicPageProps } from "@op/puck-types";
import { LazyComponent } from "../../../utils/LazyComponent";

const TopicPage = (props: TopicPageProps) => {
  return <LazyComponent<TopicPageProps> name="TopicPage" {...props} />;
};

export default TopicPage;
